import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black px-5 py-12 sm:px-8 lg:px-12">
      <div className="mx-auto grid max-w-7xl gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <img src="/Zuntly_New.png" alt="Zuntly" className="h-8 w-8 rounded-lg object-contain" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
            <span className="text-lg font-bold text-white">Zuntly</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-mute">
            App, counter, stock, and delivery for retailers and distributors - in one system your team
            can actually run day to day.
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold text-faint">Platform</p>
          <ul className="mt-3 space-y-2 text-sm text-mute">
            <li><Link to="/platform" className="hover:text-white">Surfaces</Link></li>
            <li><Link to="/features" className="hover:text-white">Features</Link></li>
            <li><Link to="/solutions" className="hover:text-white">Smart helpers</Link></li>
            <li><Link to="/subscriptions" className="hover:text-white">Plans</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-sm font-semibold text-faint">Company</p>
          <ul className="mt-3 space-y-2 text-sm text-mute">
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/privacy-policy" className="hover:text-white">Privacy</Link></li>
            <li><Link to="/delete-account" className="hover:text-white">Delete account</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-sm font-semibold text-faint">Contact</p>
          <ul className="mt-3 space-y-2 text-sm text-mute">
            <li>
              <a href="tel:+919676568515" className="hover:text-white">+91 96765 68515</a>
            </li>
            <li>
              <a href="mailto:ecom@zuntly.com" className="hover:text-white">ecom@zuntly.com</a>
            </li>
            <li>
              <a href="https://www.zuntly.com" className="hover:text-white" target="_blank" rel="noreferrer">
                www.zuntly.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mx-auto mt-12 max-w-7xl border-t border-white/10 pt-6 text-xs text-faint">
        © {new Date().getFullYear()} Zuntly Commerce System. All rights reserved.
      </div>
    </footer>
  );
}
